import React, { useState, useEffect, useRef } from "react";
import MediaDisplay from "./MediaDisplay";

const ParticipantDetailCard = ({ participant, t, isQuadMode }) => {
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const mediaIntervalRef = useRef(null);
  const mediaCarouselRef = useRef(null);
  const [mediaSize, setMediaSize] = useState(null);

  useEffect(() => {
    setCurrentMediaIndex(0);
  }, [participant])

  useEffect(() => {
    // Автоматическая смена медиа каждые 7 секунд
    if (participant.media_pairs.length > 1) {
      mediaIntervalRef.current = setInterval(() => {
        setCurrentMediaIndex(prev => 
          (prev + 1) % participant.media_pairs.length
        );
      }, 5000);
    }

    return () => {
      if (mediaIntervalRef.current) {
        clearInterval(mediaIntervalRef.current);
      }
    };
  }, [participant.media_pairs.length]);

  useEffect(() => {
    // Вычисление размера квадрата на основе доступного пространства
    const calculateMediaSize = () => {
      if (!mediaCarouselRef.current) return;
      
      const container = mediaCarouselRef.current;
      const containerWidth = container.clientWidth;
      const containerHeight = container.clientHeight;
      
      // Учитываем gap между блоками (1.5rem = 24px)
      const gap = isQuadMode ? 12 : 24;
      
      // Доступная ширина для одного блока (половина контейнера минус gap)
      const availableWidth = (containerWidth - gap) / 2;
      
      // Берём минимум из доступной ширины и высоты
      const size = Math.min(availableWidth, containerHeight);
      
      setMediaSize(size);
    };

    calculateMediaSize();
    
    // Пересчёт при изменении размера окна
    const resizeObserver = new ResizeObserver(calculateMediaSize);
    if (mediaCarouselRef.current) {
      resizeObserver.observe(mediaCarouselRef.current);
    }
    
    return () => {
      resizeObserver.disconnect();
    };
  }, [isQuadMode]);

  const currentMedia = participant.media_pairs[currentMediaIndex];
  console.log(currentMediaIndex, currentMedia);

  const getMediaStyle = () => {
    return mediaSize ? {
      width: `${mediaSize}px`,
      height: `${mediaSize}px`
    } : {};
  };

  return (
    <div className={`participant-detail-card ${isQuadMode ? 'quad-mode' : 'single-mode'}`}>
      <div className="detail-card-content">
        {/* Блок 1_1: Медиа ДО и ПОСЛЕ */}
        <div className="media-section">
          <div className="media-carousel" ref={mediaCarouselRef}>
            {currentMedia && (
              <div className="media-pair">
                <div className="media-before">
                  {/* <div className="media-label">{t.before}</div> */}
                  <MediaDisplay
                    url={currentMedia.before_url}
                    contentType={currentMedia.before_content_type}
                    label={t.before}
                    style={getMediaStyle()}
                  />
                </div>
                <div className="media-after">
                  {/* <div className="media-label">{t.after}</div> */}
                  <MediaDisplay
                    url={currentMedia.after_url}
                    contentType={currentMedia.after_content_type}
                    label={t.after}
                    style={getMediaStyle()}
                  />
                </div>
              </div>
            )}
          </div>
          
          <div className="d-flex flex-row gap-2 w-100">

            <div className="participant-name mt-2 flex-grow-1">
              <div className="participant-label">{t.participant_name}</div>
              <div className="participant-full-name">
                {participant.user.last_name} {participant.user.first_name}
              </div>
            </div>


            <div className="total-score-container-name">
              {/* {participant.has_scores && ( */}
                <div className="total-score-section">
                  <div className="total-score-label">{t.total_score}:</div>
                  <div className="total-score-value primary-text">{Number(participant.result_score).toFixed(2)}</div>
                </div>
              {/* )} */}
            </div>

          </div>
        </div>

        {/* Блок 1_2: Список судей и их оценок */}
        <div className="judges-section-container">
          <div className="judges-section">

            <h4 className="judges-title">{t.judges_title}</h4>
            {participant.judges_scores.length > 0 ? (
              <div className="judges-table">
                {participant.judges_scores.map((judgeScore, index) => (
                  <div key={index} className="judge-score-row">
                    <span className="judge-name">{judgeScore.judge_name}</span>
                    <span className="judge-score">{Number(judgeScore.score).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-scores">
                {t.no_scores_yet}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantDetailCard;